import { Col, Divider, Drawer, Row } from 'antd';
import { useMapboxContext } from '../context/mapbox-context';


const DrawerData = () => {
    const { isOpenDataDrawer, clickProperties, setIsOpenDataDrawer } = useMapboxContext();

    const onClose = () => {
        setIsOpenDataDrawer(!isOpenDataDrawer);
    }

    const showProperties = () => {
        const propertyElements = [];

        for (const prop in clickProperties) {
            if (clickProperties.hasOwnProperty(prop)) {
                const propName = prop;
                const propValue = clickProperties[propName];
                propertyElements.push(
                    <div key={propName} style={{ padding: "5px" }}>
                        <Row gutter={[16, 16]}>
                            <Col span={10}>
                                <div>{propName}:</div>
                            </Col>
                            <Col span={14} style={{textAlign:"right"}}>
                                <div>{propValue}</div>
                            </Col>
                        </Row>
                    </div>);

            }
        }

        return <>{propertyElements}</>;
    };


    return (

        <Drawer onClose={onClose} open={isOpenDataDrawer} width={"30%"} title={<div style={{ color: "white" }}>Settings</div>} style={{ backgroundColor: "black", color: "white" }}>
            <Divider orientation="left" style={{ color: "white", borderColor: "white" }}>Data:</Divider>
            {showProperties()}
        </Drawer>
    );
}

export default DrawerData;
